import api from '@/services/api'
import ActionActions from './actions-types'

export default {
  [ActionActions.GET_ALL_ACTIONS]({}, options) {
    return new Promise((resolve, reject) => {
      api.node.action
        .getActions(options)
        .then((response) => {
          resolve(response.data)
        })
        .catch(() => reject())
    })
  },

  [ActionActions.SAVE_ACTION]({ state }) {
    return new Promise((resolve, reject) => {
      let data = {}
      state.fields.forEach((item) => {
        data[item.name] = item.value
      })

      // Ensure action_url is always an empty string, never null
      if (data.action_url === null || data.action_url === undefined) {
        data.action_url = '127.0.0.1'
      }

      // Ensure built_in is always false, never null
      if (data.built_in === null || data.built_in === undefined) {
        data.built_in = false
      }

      // Ensure pipeline_id is a number (integer) if provided, or null if empty
      if (data.pipeline_id !== null && data.pipeline_id !== undefined && data.pipeline_id !== '') {
        data.pipeline_id = parseInt(data.pipeline_id, 10)
      } else {
        data.pipeline_id = null
      }

      // Ensure default_icon_id is a number (integer) if provided, or null if empty
      if (data.default_icon_id !== null && data.default_icon_id !== undefined && data.default_icon_id !== '') {
        data.default_icon_id = parseInt(data.default_icon_id, 10)
      } else {
        data.default_icon_id = null
      }

      if (state.selectedAction) {
        api.node.action
          .updateAction(data, state.selectedAction.action_id)
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error.response ? error.response.data : error)
          })
      } else {
        api.node.action
          .createAction(data)
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error.response ? error.response.data : error)
          })
      }
    })
  },

  [ActionActions.UPDATE_ACTION]({ state }, data) {
    return new Promise((resolve, reject) => {
      api.node.action
        .updateAction(data, state.selectedAction.action_id)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error.response ? error.response.data : error)
        })
    })
  },

  [ActionActions.DELETE_ACTION]({}, actionId) {
    return new Promise((resolve, reject) => {
      api.node.action
        .deleteAction(actionId)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error.response ? error.response.data : error)
        })
    })
  }
}
